import AiAgentTemplate from '../../../../components/units/Management/AiAgent/Template/List';

export default function AiAgentTemplatePage() {
  return <AiAgentTemplate />;
}
